import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('carrier_brand', '/carrier_brands')
const actions = generator.generate()

export default actions
